import { useEffect, useState } from 'react';
import PaymentBatchService from '../../../services/paymentBatchService';
import { subsidyFilterToQueryValue } from '../constants';

export const useFetchPaymentBatches = ({
  organizationId,
  propertyId,
  subsidyFilter,
  periodFilter,
}) => {
  const [paymentBatches, setPaymentBatches] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    // $FlowFixMe
    const abortController = new AbortController(); // eslint-disable-line
    const fetchPaymentBatches = async () => {
      setIsLoading(true);
      try {
        const paymentBatchService = new PaymentBatchService();
        const isSubsidyBatch = subsidyFilterToQueryValue(subsidyFilter);
        const response = await paymentBatchService.getAllPaymentBatches(
          organizationId,
          propertyId,
          {
            isSubsidyBatch,
            period: periodFilter || null,
            signal: abortController.signal,
          },
        );

        setPaymentBatches(response);
      } catch (error) {
        if (abortController.signal.aborted) {
          return;
        }
        setPaymentBatches([]);
      } finally {
        if (!abortController.signal.aborted) {
          setIsLoading(false);
        }
      }
    };
    if (organizationId && propertyId) fetchPaymentBatches();

    return () => abortController.abort();
  }, [organizationId, propertyId, subsidyFilter, periodFilter]);

  return { paymentBatches, isLoading };
};
